import { render, staticRenderFns } from "./MnvAnalysisPeriodTable.vue?vue&type=template&id=31764140&scoped=true"
import script from "./MnvAnalysisPeriodTable.vue?vue&type=script&lang=js"
export * from "./MnvAnalysisPeriodTable.vue?vue&type=script&lang=js"
import style0 from "./MnvAnalysisPeriodTable.vue?vue&type=style&index=0&id=31764140&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31764140",
  null
  
)

export default component.exports